<template>
  <div class="a-inspection-route-map-container">
    <!-- 搜索和定位控制栏 -->
    <div class="map-toolbar">
      <div class="search-box">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索地点"
          class="search-input"
          clearable
          @clear="clearSearch"
          @keyup.enter.native="searchLocation"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="searchLocation">搜索</el-button>
      </div>
      <el-button type="primary" plain icon="el-icon-location" @click="locateCurrentPosition" class="locate-btn">
        定位到当前位置
      </el-button>
    </div>

    <!-- 搜索结果下拉列表 -->
    <div v-if="searchResults.length > 0" class="search-results">
      <div
        v-for="(result, index) in searchResults"
        :key="index"
        class="search-result-item"
        @click="goToSearchResult(result)"
      >
        <div class="result-title">{{ result.title }}</div>
        <div class="result-address">{{ result.address }}</div>
      </div>
    </div>

    <!-- 地图容器 -->
    <div id="aInspectionRouteMap" class="map-container"></div>
  </div>
</template>

<script>
import { listAdminInspectionRoutePoints } from '@/api/inspection/aInspectionPlanDetailApi'

export default {
  name: 'AInspectionRouteMap',
  data() {
    return {
      map: null,
      points: [],
      searchKeyword: '',
      searchResults: [],
      mapKey: '',
      currentLocationMarker: null
    }
  },
  async created() {
    await this.loadQQMapScript()
  },
  methods: {
    loadQQMapScript() {
      console.log('[地图加载] 开始加载腾讯地图SDK')
      // 如果TMap已经存在且有key，直接使用（HTML中已加载的SDK）
      if (window.TMap && window.TMap.key) {
        this.mapKey = window.TMap.key
        console.log('[地图加载] TMap已存在，使用已有密钥:', this.mapKey.substring(0, 4) + '****')
        return Promise.resolve()
      }

      // 如果TMap存在但没有key，说明HTML中没有正确配置SDK，需要动态加载
      if (window.TMap) {
        return new Promise((resolve, reject) => {
          var script = document.createElement('script')
          script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=VCPBZ-T4JYU-U6DVD-GN6XF-2WBLH-BQFT7'
          console.log('[地图加载] 创建script标签，加载腾讯地图SDK')
          script.onload = () => {
            this.mapKey = window.TMap.key || ''
            console.log('[地图加载] SDK加载成功，密钥:', this.mapKey ? this.mapKey.substring(0, 4) + '****' : '未配置')
            resolve()
          }
          script.onerror = (e) => {
            console.error('[地图加载] SDK加载失败', e)
            reject(e)
          }
          document.head.appendChild(script)
        })
      }

      // 如果TMap完全不存在，也尝试加载
      return new Promise((resolve, reject) => {
        var script = document.createElement('script')
        script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=VCPBZ-T4JYU-U6DVD-GN6XF-2WBLH-BQFT7'
        console.log('[地图加载] 创建script标签，加载腾讯地图SDK')
        script.onload = () => {
          this.mapKey = window.TMap.key || ''
          console.log('[地图加载] SDK加载成功，密钥:', this.mapKey ? this.mapKey.substring(0, 4) + '****' : '未配置')
          resolve()
        }
        script.onerror = (e) => {
          console.error('[地图加载] SDK加载失败', e)
          reject(e)
        }
        document.head.appendChild(script)
      })
    },
    async initMap(params) {
      try {
        const { data } = await listAdminInspectionRoutePoints({
          inspectionRouteId: params.inspectionRouteId,
          page: 1,
          row: 1000
        })
        this.points = data
        this.initMapView()
      } catch (error) {
        this.$message.error(this.$t('common.fetchError'))
      }
    },
    initMapView() {
      console.log('[地图初始化] 开始初始化地图视图')

      // 清理之前的标记
      if (this.currentLocationMarker) {
        console.log('[地图初始化] 清除之前的定位标记')
        this.currentLocationMarker.setMap(null)
        this.currentLocationMarker = null
      }
      if (this.map) {
        console.log('[地图初始化] 销毁旧地图实例')
        this.map.destroy()
        this.map = null
      }

      if (!this.points || this.points.length === 0) {
        console.warn('[地图初始化] 没有巡检点数据')
        return
      }
      console.log('[地图初始化] 巡检点数量:', this.points.length)

      // 使用腾讯地图API
      if (window.TMap) {
        var center = new window.TMap.LatLng(this.points[0].lat, this.points[0].lng)
        console.log('[地图初始化] 地图中心点:', this.points[0].lat, this.points[0].lng)
        this.map = new window.TMap.Map(document.getElementById('aInspectionRouteMap'), {
          center: center,
          zoom: 16,
          baseMap: {
            type: 'vector',
            features: ['base', 'building2d', 'point']
          }
        })
        console.log('[地图初始化] 地图实例创建成功')

        var geometriesMarker = []
        var geometriesLabel = []
        var path = []

        this.points.forEach(function(point) {
          if (!point.lat || !point.lng) return

          var position = new window.TMap.LatLng(point.lat, point.lng)

          geometriesMarker.push({
            id: point.inspectionId,
            styleId: 'myStyle',
            position: position
          })

          geometriesLabel.push({
            id: 'label_' + point.inspectionId,
            styleId: 'label',
            position: position,
            content: point.inspectionName
          })

          path.push(position)
        })

        console.log('[地图初始化] 创建标记图层，点位数量:', geometriesMarker.length)
        // 创建标记图层
        new window.TMap.MultiMarker({
          map: this.map,
          styles: {
            'myStyle': new window.TMap.MarkerStyle({
              width: 25,
              height: 35,
              src: '/img/maper.png',
              anchor: { x: 32, y: 32 }
            })
          },
          geometries: geometriesMarker
        })

        console.log('[地图初始化] 创建标签图层')
        // 创建标签图层
        new window.TMap.MultiLabel({
          map: this.map,
          styles: {
            'label': new window.TMap.LabelStyle({
              color: '#3777FF',
              size: 20,
              offset: { x: 0, y: 15 },
              angle: 0,
              alignment: 'center',
              verticalAlignment: 'middle'
            })
          },
          geometries: geometriesLabel
        })

        // 创建路径图层
        if (path.length > 1) {
          console.log('[地图初始化] 创建路径图层，路径点数:', path.length)
          new window.TMap.MultiPolyline({
            map: this.map,
            styles: {
              'style_blue': new window.TMap.PolylineStyle({
                color: '#3777FF',
                width: 6,
                borderWidth: 5,
                borderColor: '#FFF',
                lineCap: 'butt'
              })
            },
            geometries: [{
              id: 'pl_1',
              styleId: 'style_blue',
              paths: path
            }]
          })
        }
        console.log('[地图初始化] 地图视图初始化完成')
      } else {
        console.error('[地图初始化] TMap未定义，无法初始化地图')
      }
    },

    // 定位到当前位置
    locateCurrentPosition() {
      console.log('[GPS定位] 开始获取当前位置')
      var _this = this
      if (!this.map) {
        console.warn('[GPS定位] 地图未初始化')
        this.$message.warning('地图尚未初始化')
        return
      }

      if (navigator.geolocation) {
        console.log('[GPS定位] 浏览器支持地理定位，开始请求')
        navigator.geolocation.getCurrentPosition(function(position) {
          var lat = position.coords.latitude
          var lng = position.coords.longitude
          var accuracy = position.coords.accuracy
          console.log('[GPS定位] 获取位置成功，纬度:', lat, '经度:', lng, '精度:', accuracy, '米')
          _this.showCurrentLocation(lat, lng)
        }, function(error) {
          console.error('[GPS定位] 获取位置失败，错误码:', error.code, '错误信息:', error.message)
          var errorMsg = '定位失败，请检查浏览器定位权限设置'
          if (error.code === 1) {
            errorMsg = '定位失败，请允许浏览器获取位置权限'
          } else if (error.code === 2) {
            errorMsg = '定位失败，无法获取位置信息'
          } else if (error.code === 3) {
            errorMsg = '定位超时，请重试'
          }
          _this.$message.error(errorMsg)
        }, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000
        })
      } else {
        console.error('[GPS定位] 当前浏览器不支持地理定位')
        this.$message.error('当前浏览器不支持地理定位')
      }
    },

    // 在地图上显示当前位置
    showCurrentLocation(lat, lng) {
      console.log('[显示位置] 开始显示位置，纬度:', lat, '经度:', lng)
      var position = new window.TMap.LatLng(lat, lng)

      if (this.currentLocationMarker) {
        console.log('[显示位置] 清除之前的定位标记')
        this.currentLocationMarker.setMap(null)
      }

      console.log('[显示位置] 创建定位标记')
      this.currentLocationMarker = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          'currentLocation': new window.TMap.MarkerStyle({
            'width': 30,
            'height': 30,
            'src': 'https://mapapi.qq.com/web/jsapi/demo/img/center.gif',
            'anchor': { x: 15, y: 15 }
          })
        },
        geometries: [{
          id: 'current_location',
          styleId: 'currentLocation',
          position: position
        }]
      })

      console.log('[显示位置] 移动地图中心点，设置缩放级别为16')
      this.map.setCenter(position)
      this.map.setZoom(16)
      this.$message.success('已定位到当前位置')
    },

    // 搜索位置 - 使用腾讯地图WebService API
    searchLocation() {
      console.log('[位置搜索] 开始搜索，关键词:', this.searchKeyword)

      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        console.warn('[位置搜索] 搜索关键词为空')
        this.$message.warning('请输入搜索关键词')
        return
      }

      if (!this.mapKey) {
        console.error('[位置搜索] 地图密钥未配置，无法执行搜索')
        this.$message.error('地图密钥未配置')
        return
      }

      var _this = this
      var keyword = encodeURIComponent(this.searchKeyword.trim())
      console.log('[位置搜索] 编码后的关键词:', keyword)

      var url = 'https://apis.map.qq.com/ws/place/v1/search?keyword=' + keyword + '&boundary=region(全国,0)&key=' + this.mapKey + '&output=jsonp&callback=JSONP_CALLBACK2'
      console.log('[位置搜索] 请求URL:', url.replace(this.mapKey, this.mapKey.substring(0, 4) + '****'))

      var script = document.createElement('script')
      script.src = url
      console.log('[位置搜索] 创建JSONP请求')

      window.JSONP_CALLBACK2 = function(response) {
        console.log('[位置搜索] 收到响应，状态码:', response.status, '数据条数:', response.data ? response.data.length : 0)
        delete window.JSONP_CALLBACK2
        if (script.parentNode) {
          document.body.removeChild(script)
        }

        if (response.status === 0 && response.data && response.data.length > 0) {
          console.log('[位置搜索] 搜索成功，前3条结果:', JSON.stringify(response.data.slice(0, 3)))
          _this.searchResults = response.data.slice(0, 10)
          _this.$message.success('找到 ' + _this.searchResults.length + ' 个结果')
        } else {
          console.warn('[位置搜索] 搜索失败，状态:', response.status, '信息:', response.message)
          _this.searchResults = []
          _this.$message.info('未找到相关位置')
        }
      }

      setTimeout(function() {
        if (window.JSONP_CALLBACK2) {
          console.warn('[位置搜索] 请求超时')
          delete window.JSONP_CALLBACK2
          if (script.parentNode) {
            document.body.removeChild(script)
          }
          _this.$message.error('搜索超时，请重试')
        }
      }, 10000)

      script.onerror = function(e) {
        console.error('[位置搜索] 网络请求失败', e)
        delete window.JSONP_CALLBACK2
        if (script.parentNode) {
          document.body.removeChild(script)
        }
        _this.$message.error('搜索失败，请检查网络连接')
      }

      document.body.appendChild(script)
      console.log('[位置搜索] JSONP脚本已添加到DOM，等待响应...')
    },

    // 点击搜索结果，定位到该位置
    goToSearchResult(result) {
      console.log('[搜索结果] 点击搜索结果:', JSON.stringify(result))

      if (!this.map) {
        console.warn('[搜索结果] 地图未初始化')
        return
      }

      var lat = result.location && result.location.lat
      var lng = result.location && result.location.lng
      console.log('[搜索结果] 解析坐标，纬度:', lat, '经度:', lng)

      if (lat && lng) {
        var position = new window.TMap.LatLng(lat, lng)

        if (this.currentLocationMarker) {
          console.log('[搜索结果] 清除之前的定位标记')
          this.currentLocationMarker.setMap(null)
        }

        console.log('[搜索结果] 创建搜索结果标记')
        this.currentLocationMarker = new window.TMap.MultiMarker({
          map: this.map,
          styles: {
            'searchResult': new window.TMap.MarkerStyle({
              'width': 30,
              'height': 40,
              'src': 'https://mapapi.qq.com/web/jsapi/demo/img/center.gif',
              'anchor': { x: 15, y: 35 }
            })
          },
          geometries: [{
            id: 'search_result',
            styleId: 'searchResult',
            position: position
          }]
        })

        console.log('[搜索结果] 移动地图中心点，设置缩放级别为16')
        this.map.setCenter(position)
        this.map.setZoom(16)
        console.log('[搜索结果] 定位完成')
      } else {
        console.warn('[搜索结果] 无法获取有效坐标')
      }

      console.log('[搜索结果] 清除搜索结果列表')
      this.searchResults = []
    },

    // 清除搜索
    clearSearch() {
      this.searchResults = []
      this.searchKeyword = ''
    }
  }
}
</script>

<style scoped>
.a-inspection-route-map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
  z-index: 100;
}

.search-box {
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 400px;
}

.search-input {
  width: 280px;
  margin-right: 8px;
}

.locate-btn {
  white-space: nowrap;
}

.search-results {
  position: absolute;
  top: 70px;
  left: 12px;
  width: 380px;
  max-height: 400px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.search-result-item {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background-color: #f5f5f5;
}

.result-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.result-address {
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-container {
  height: 600px;
  width: 100%;
}
</style>